import { FC, useContext } from 'react';
import PageContext from '../../context/PageContext';
import AdSlotBase from './AdSlotBase';

interface StaticAdSlotProps {
  adKey: string;
}

export const StaticAdSlot: React.FC<StaticAdSlotProps> = ({ adKey }) => {
  const pageContext = useContext(PageContext);

  if (!pageContext.adSlots?.[adKey]) {
    return null;
  }

  return <AdSlotBase data={pageContext.adSlots[adKey]} />;
};
